import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '@/app/hooks';
import { ProfitInfo } from '@/entities/profit';
import { setMobileSidebar } from '@/features/sidebar';
import { Icon } from '@/shared/IconCollecion';
import { Logo } from '@/shared/ui/Logo';

// Верхняя панель телефона (до md) для compactNav = 'rail-topbar', макет telecom
// (раздел 5): винная полоса 60px — бургер, логотип, баланс основного кошелька.
// Бургер открывает меню на весь экран (MobileMenu). Баланс — та же пилюля с
// дропдауном кошельков, что в строке аккаунта, только тёмная и с одной суммой.
export const MobileTopBar = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common');

  return (
    <div className="flex h-[60px] shrink-0 items-center gap-2 bg-surface-sidebar pl-2 pr-3 md:hidden">
      <button
        type="button"
        aria-label={t('openMenu')}
        data-testid="mobile-menu-trigger"
        className="flex size-11 items-center justify-center text-content-inverse"
        onClick={() => dispatch(setMobileSidebar(true))}
      >
        <Icon name="Burger" color="currentColor" className="size-[22px]" />
      </button>
      <Link to="/" aria-label={import.meta.env.VITE_BRAND_TITLE}>
        <Logo min={false} size="small" />
      </Link>
      <ProfitInfo variant="pill" compact className="ml-auto" />
    </div>
  );
};

export default MobileTopBar;
